import { ConfirmDialog } from "@/components/common";
import { useTran } from "@/hooks";

const DeleteMasterDataDialog = ({
  open,
  onOpenChange,
  item = null,
  items = [],
  handleDelete,
  handleDeleteAll,
}) => {
  const { t } = useTran();
  const normalizedItems =
    Array.isArray(items) && items.length > 0
      ? items.filter(Boolean)
      : item
        ? [item]
        : [];
  const deletableItems = normalizedItems.filter(
    (entry) => !entry?.useInTargetSetup && !entry?.useInDataEntry,
  );
  const itemCount = deletableItems.length;
  const isBulkDelete = normalizedItems.length > 1;

  if (!itemCount) return null;

  const handleConfirm = async () => {
    if (isBulkDelete) {
      await handleDeleteAll?.(normalizedItems);
    } else if (deletableItems[0]?.id) {
      await handleDelete?.(deletableItems[0].id);
    }

    onOpenChange(false);
  };

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t("Confirm Remove")}
      description={
        isBulkDelete
          ? t(
              `Are you sure you want to remove ${itemCount} metric assignments?`,
            )
          : t("Are you sure you want to remove this metric assignment?")
      }
      confirmLabel={t("Remove")}
      cancelLabel={t("Cancel")}
      onConfirm={() => void handleConfirm()}
      tone="danger"
    />
  );
};

export default DeleteMasterDataDialog;
